<script setup>
import moment from "moment";
moment.locale("id");
</script>

<template>
  <DefaultLayout>
    <v-row class="mx-5 mt-5">
      <v-col cols="12">
        <div
          class="bg-red-ss rounded-top-10 w-100 border border-1 pt-2"
          style="min-height: 5vh"
        >
          <div style="color: #28293d" class="px-3 pb-2">
            <button @click="$router.back()" class="btn">
              <font-awesome-icon
                icon="fa-solid fa-arrow-left"
                style="color: #28293d"
              />
            </button>
            Penilaian Materi Presentasi : {{ namaAspek }}
          </div>
          <div
            class="bg-white rounded-top-10 w-100 border border-1 shadow-sm p-2"
            style="min-height: 60vh"
          >
            <div class="container p-4">
              <div class="container my-4">
                <penilaianCalonPenanggungJawab :dataPJO="dataPJO" />

                <p
                  class="mb-3 mt-4"
                  style="
                    font-family: 'Inter-Thin';
                    font-size: 0.9rem;
                    letter-spacing: 0.1rem;
                    font-weight: bold;
                  "
                >
                  PENILAIAN MATERI PRESENTASI
                </p>
                <p class="text-danger fst-italic fs-8 fw-bold">
                  * Silahkan gunakan indikator <b>(+) (-)</b> untuk mengisi skor
                  penilaian
                </p>
                <formPenilaianAspek
                  :evaluationItems="evaluationItems"
                  @updateEvaluationItems="evaluationItems = $event"
                  :penilaians="penilaians"
                  :dataPJO="dataPJO"
                  :dataSio="dataSio"
                  :idKustodian="idKustodian"
                  :namaKustodian="namaKustodian"
                />

                <div class="d-flex justify-content-end mt-3">
                  <template v-if="penilaians != null && penilaians.length != 0">
                    <button
                      type="button"
                      class="btn btn_cari w-25"
                      @click="submitPenilaian(idPenilaianAspek, 'sub-aspek')"
                      v-if="
                        (penilaians.filter(
                          (item) => item.idKustodian == userData.id
                        ).length > 0
                          ? penilaians.filter(
                              (item) => item.idKustodian == userData.id
                            )[0].idKustodian == userData.id
                          : false) &&
                        moment(dataPJO.tanggalPresentasi).format(
                          'YYYY-MM-DD'
                        ) == moment(new Date()).format('YYYY-MM-DD')
                      "
                      :hidden="
                        dataSio.status == 5 ||
                        dataSio.status == 6 ||
                        dataSio.status == 7 ||
                        dataSio.status == 8 ||
                        dataSio.status == 3
                      "
                    >
                      Approve
                    </button>
                    <template
                      v-if="
                        penilaians.filter(
                          (item) => item.idKustodian == userData.id
                        ).length == 0 &&
                        evaluationItems != null &&
                        evaluationItems.length > 0
                      "
                    >
                      <button
                        type="button"
                        class="btn btn_cari w-25"
                        @click="submitPenilaian(idPenilaianAspek, 'sub-aspek')"
                        v-if="
                          idKustodian == userData.id &&
                          moment(dataPJO.tanggalPresentasi).format(
                            'YYYY-MM-DD'
                          ) == moment(new Date()).format('YYYY-MM-DD')
                        "
                        :hidden="
                          dataSio.status == 5 ||
                          dataSio.status == 6 ||
                          dataSio.status == 7 ||
                          dataSio.status == 8 ||
                          dataSio.status == 3
                        "
                      >
                        Approve
                      </button>
                    </template>
                  </template>

                  <template v-else>
                    <button
                      type="button"
                      class="btn btn_cari w-25"
                      @click="submitPenilaian(idPenilaianAspek, 'sub-aspek')"
                      v-if="
                        idKustodian == userData.id &&
                        moment(dataPJO.tanggalPresentasi).format(
                          'YYYY-MM-DD'
                        ) == moment(new Date()).format('YYYY-MM-DD')
                      "
                      :hidden="
                        dataSio.status == 5 ||
                        dataSio.status == 6 ||
                        dataSio.status == 7 ||
                        dataSio.status == 8 ||
                        dataSio.status == 3
                      "
                    >
                      Approve
                    </button>
                  </template>
                </div>
              </div>
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
  </DefaultLayout>
</template>

<script>
// import router from "../router";
// import SidebarComponent from "@/components/SideBar.vue";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import GlobalDataMixin from "../../../../GlobalDataMixin";
// import Datepicker from "vuejs3-datepicker"
import axios from "axios";
import Swal from "sweetalert2";
import {
  API_BASE_URL,
  CMS_GET_SIOID,
  CMS_GET_JADWALNILAI,
  CMS_GET_PENILAIANDETAIL,
  CMS_SET_PENILAIAN,
  CMS_GET_PENILAIANASPEK,
} from "@/constants";

import "@/pages/sio/assets/penilaian-presentasi.css";
import penilaianCalonPenanggungJawab from "@/pages/sio/penilaian/penilaianCalonPenanggungJawab.vue";
import formPenilaianAspek from "@/pages/sio/penilaian/formPenilaianAspek.vue";
import DefaultLayout from "@/layouts/DefaultLayout.vue";

const url_get_sioid = API_BASE_URL + CMS_GET_SIOID;
const url_get_jadwal = API_BASE_URL + CMS_GET_JADWALNILAI;
const url_get_penilaiandetail = API_BASE_URL + CMS_GET_PENILAIANDETAIL;
const url_get_penilaianaspek = API_BASE_URL + CMS_GET_PENILAIANASPEK;
const url_set_penilaian = API_BASE_URL + CMS_SET_PENILAIAN;

export default {
  mixins: [GlobalDataMixin],
  name: "aspekTeknikOperasional",
  components: {
    FontAwesomeIcon,
    DefaultLayout,
    formPenilaianAspek,
    penilaianCalonPenanggungJawab,
  },
  data() {
    return {
      role: "",
      isLoading: true,
      sioID: null,
      kontraktorid: null,
      idAspek: null,
      namaAspek: null,
      jenisPenilaian: "presentasi",
      idPenjadwalan: null,
      idPenilaianAspek: null,
      idKustodian: null,
      namaKustodian: null,
      dataPJO: {
        nama: null,
        perusahaan: null,
        tanggalPresentasi: null,
      },
      evaluationItems: [],
      penilaians: [],
    };
  },
  mounted() {
    this.role = "isafe";
    this.sioID = this.$route.params.id;
    this.kontraktorid = this.$route.params.kontraktorid;
    this.idAspek = parseInt(this.$route.params.idaspek);
    this.idPenjadwalan = this.$route.params.idpenjadwalan;
    this.getSioID(this.kontraktorid);
    this.getJadwal(this.idPenjadwalan);
  },
  methods: {
    getSioID(id) {
      axios
        .get(url_get_sioid + id, {
          headers: {
            role: this.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response nya = ", response);

          let dt = null;
          dt = response.data.data;
          if (dt != null) {
            this.dataSio = dt;
            this.sioID = dt.id;
          }

          this.isLoading = false;
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getSioID : " + error.message);
          console.error("Error fetching data getSioID :", error.message);
        });
    },
    getJadwal(idpenjadwalan) {
      axios
        .get(url_get_jadwal + idpenjadwalan, {
          headers: {
            role: this.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response getJadwal :  ", response);
          let dtj = response.data;

          this.idPenjadwalan = dtj.idPenjadwalan;
          this.getPenilaianDetail(this.idPenjadwalan, this.jenisPenilaian);
          this.getPenilaianAspek();
        })
        .catch((error) => {
          this.isLoading = false;
          alert("Error Fetch Data getJadwal : " + error);
          console.error("Error fetching data getJadwal :", error);
        });
    },
    getPenilaianDetail(idPenjadwalan, jenis) {
      let bodyJson = {
        idPenjadwalan: idPenjadwalan,
        jenis: jenis,
      };

      axios
        .post(url_get_penilaiandetail, bodyJson, {
          headers: {
            role: this.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response getPenilaianDetail ", jenis, " : ", response);
          if (response.data !== undefined && response.data !== null) {
            let dt = response.data;
            let dtpenilaian = dt.dataPenilaian;
            if (jenis == "administrasi") {
              this.dataPJO.nama = dt.pjo;
              this.dataPJO.perusahaan = dt.perusahaan;
              this.dataPJO.tanggalPresentasi = dt.schedule;
              this.idPenilaianAdmin = dtpenilaian[0].id;
              let pn = JSON.parse(dtpenilaian[0].penilaian);
              if (
                JSON.parse(dtpenilaian[0].penilaian).penilaian !== undefined
              ) {
                pn = JSON.parse(dtpenilaian[0].penilaian).penilaian;
              }
              this.dataPenilaianAdmin = pn;

              console.log("this.dataPenilaianAdmin:", this.dataPenilaianAdmin);
            } else if (jenis == "kompetensi") {
              this.dataPenilaianKompetensi = JSON.parse(
                dtpenilaian[0].penilaian
              ).penilaian;
              console.log(
                "this.dataPenilaianKompetensi:",
                this.dataPenilaianKompetensi
              );
            } else if (jenis == "presentasi") {
              this.dataPenilaianMateri = JSON.parse(
                dtpenilaian[0].penilaian
              ).penilaian;
              console.log(
                "this.dataPenilaianMateri:",
                this.dataPenilaianMateri
              );
              let na = this.dataPenilaianMateri.filter(
                (option) => option.idAspek == this.idAspek
              );
              this.namaAspek = na.length > 0 ? na[0].aspek : "-";
            }
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error getPenilaianDetail ", jenis, " : ", error);
          alert("error getPenilaianDetail ", jenis, " : ", error);
        })
        .then(() => {});
    },
    getPenilaianAspek() {
      let bodyJson = {
        aspekId: parseInt(this.idAspek),
        idPenjadwalan: this.idPenjadwalan,
      };
      axios
        .post(url_get_penilaianaspek, bodyJson, {
          headers: {
            role: this.role,
            Authorization: "Bearer " + this.userData.token,
            accept: "application/json",
          },
        })
        .then((response) => {
          console.log("response getPenilaianAspek : ", response);
          if (response.data !== undefined && response.data !== null) {
            let dt = response.data;
            this.dataPJO.nama = dt.pjo;
            this.dataPJO.perusahaan = dt.perusahaan;
            this.dataPJO.tanggalPresentasi = dt.schedule;
            this.idPenilaianAspek = dt.idPenilaian;
            this.evaluationItems = dt.penilaian;
            this.penilaians = dt.penilaians;
            this.idKustodian = dt.idKustodian;
            this.namaKustodian = dt.kustodian;
          }
        })
        .catch((error) => {
          this.isLoading = false;
          console.log("error getPenilaianAspek : ", error);
          alert("error getPenilaianAspek : ", error);
        })
        .then(() => {});
    },
    submitPenilaian(idpenilaian, jenis) {
      Swal.fire({
        title: "Konfirmasi",
        text: "Apakah Anda yakin akan simpan data ini ?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#1db61d",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Simpan",
        cancelButtonText: "Batal",
      }).then((result) => {
        if (result.isConfirmed) {
          let bodyJson = {};
          let penilaian = "";
          if (this.penilaians != null && this.penilaians.length != 0) {
            let temppen =
              this.penilaians.filter(
                (item) => item.idKustodian == this.userData.id
              ).length > 0
                ? this.penilaians.filter(
                    (item) => item.idKustodian == this.userData.id
                  )[0].penilaian
                : [];
            if (
              this.penilaians.filter(
                (item) => item.idKustodian == this.userData.id
              ).length == 0 &&
              this.evaluationItems != null &&
              this.evaluationItems.length > 0
            ) {
              temppen = this.evaluationItems;
            }
            penilaian = JSON.stringify({ penilaian: temppen });
          } else {
            penilaian = JSON.stringify({ penilaian: this.evaluationItems });
          }

          let totskor = 0;
          let tempskor = 0;
          let tempskormax = 0;
          if (this.penilaians != null && this.penilaians.length != 0) {
            let temppen =
              this.penilaians.filter(
                (item) => item.idKustodian == this.userData.id
              ).length > 0
                ? this.penilaians.filter(
                    (item) => item.idKustodian == this.userData.id
                  )[0].penilaian
                : [];
            if (
              this.penilaians.filter(
                (item) => item.idKustodian == this.userData.id
              ).length == 0 &&
              this.evaluationItems != null &&
              this.evaluationItems.length > 0
            ) {
              temppen = this.evaluationItems;
            }
            for (let x = 0; x < temppen.length; x++) {
              let eva = temppen[x];
              tempskor += eva.skor;
              tempskormax += eva.skorMax;
            }
          } else {
            for (let x = 0; x < this.evaluationItems.length; x++) {
              let eva = this.evaluationItems[x];
              tempskor += eva.skor;
              tempskormax += eva.skorMax;
            }
          }
          totskor = ((tempskor / tempskormax) * 100).toFixed(2);

          if (idpenilaian == null) {
            bodyJson = {
              idPenjadwalan: this.idPenjadwalan,
              penilaian: penilaian,
              jenis: jenis,
              created_by: this.userData.id,
              skor: parseFloat(totskor),
              parentAspek: parseInt(this.idAspek),
              jenisParent: this.jenisPenilaian,
            };
          } else {
            bodyJson = {
              id: idpenilaian,
              idPenjadwalan: this.idPenjadwalan,
              penilaian: penilaian,
              jenis: jenis,
              created_by: this.userData.id,
              skor: parseFloat(totskor),
              parentAspek: parseInt(this.idAspek),
              jenisParent: this.jenisPenilaian,
            };
          }
          //   console.log(url_set_penilaian);
          //   console.log(bodyJson);

          axios
            .post(url_set_penilaian, bodyJson, {
              headers: {
                role: this.role,
                Authorization: "Bearer " + this.userData.token,
                accept: "application/json",
              },
            })
            .then((response) => {
              console.log("response setPenilaian : ", response);
              this.alertSuksesSubmitPenilaian(jenis);
            })
            .catch((error) => {
              this.isLoading = false;
              console.log("error setPenilaian : ", error);
              alert("error setPenilaian : ", error);
            })
            .then(() => {});
        }
      });
    },
    alertSuksesSubmitPenilaian(jenis) {
      let msg_title = "";
      let msg_text = "";
      if (jenis == "administrasi") {
        msg_title = "Simpan Penilaian Berhasil";
        msg_text = "Penilaian Administrasi Berhasil Disimpan!";
      } else if (jenis == "kompetensi") {
        msg_title = "Simpan Penilaian Berhasil";
        msg_text = "Penilaian Kompetensi Berhasil Disimpan!";
      } else if (jenis == "presentasi") {
        msg_title = "Simpan Penilaian Berhasil";
        msg_text = "Penilaian Materi Presentasi Berhasil Disimpan!";
      } else if (jenis == "sub-aspek") {
        msg_title = "Simpan Penilaian Materi Presentasi Berhasil";
        msg_text = "Penilaian " + this.namaAspek + " Berhasil Disimpan!";
      }
      // this.isLoading = false
      Swal.fire({
        title: msg_title,
        text: msg_text,
        icon: "success",
        showConfirmButton: false,
        timer: 2000,
        showClass: {
          popup: "animate__animated animate__fadeInDown",
        },
        hideClass: {
          popup: "animate__animated animate__fadeOutUp",
        },
      }).then(() => {
        // this.$router.back()
        window.location.reload();
      });
    },
  },
};
</script>

<style></style>
